import { render } from "./TeacherTimetablePage.vue?vue&type=template&id=9e50ae38&scoped=true"
import script from "./TeacherTimetablePage.vue?vue&type=script&lang=js"
export * from "./TeacherTimetablePage.vue?vue&type=script&lang=js"

import "./TeacherTimetablePage.vue?vue&type=style&index=0&id=9e50ae38&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e50ae38"]])

export default __exports__